export default __webpack_public_path__ + "static/media/AboutUsBanner.88800134.png";